import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'BulletItem',
    props: {
        bulletImage: {},
        caption: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createBlock(_component_v_row, { class: "bullet-row" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "1" }, {
                        default: _withCtx(() => [
                            _createElementVNode("img", { src: _ctx.bulletImage }, null, 8, _hoisted_1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_col, { class: "caption" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.caption), 1)
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
